import Vue from 'vue';
import VueRouter from 'vue-router';
import LocalStorage from '@/services/localstorage';
import store from './store';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'page-not-found',
    component: () => import('./views/error/NotFound.vue'),
    meta: {
      publicPage: true,
    },
  },
  {
    path: '/',
    name: 'index',
    component: () => import('./views/app/Index.vue'),
    meta: {
      authorizedPage: true,
    },
  },
  {
    path: '/multicolli',
    name: 'multicolli',
    component: () => import('./views/app/Multicolli.vue'),
    meta: {
      authorizedPage: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/auth/Login.vue'),
    meta: {
      publicPage: true,
      needRedirectToIndex: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = router.app.$session.exists();
  const publicPage = to.matched.some((record) => record.meta.publicPage);
  // const authorizedPage = to.matched.some((record) => record.meta.authorizedPage);
  const needRedirectToIndex = to.matched.some((record) => record.meta.needRedirectToIndex);

  if (loggedIn) {
    const token = router.app.$session.get('jwt');
    const expiredUnixTime = JSON.parse(atob(token.split('.')[1])).exp;
    const currentDateTime = new Date();
    const expiredDateTime = new Date(expiredUnixTime * 1000);
    // const expiredDateTime = new Date(1615276495 * 1000);
    if (currentDateTime > expiredDateTime) {
      store.dispatch('logout');
      router.app.$session.destroy();
      return next({
        path: '/login',
      });
    }
  }

  if (!loggedIn && !publicPage) {
    return next({
      path: '/login',
    });
  }

  if (loggedIn && needRedirectToIndex) {
    const isMulticolliMerchant = LocalStorage.isMulticolliMerchant();
    if (isMulticolliMerchant) {
      return next({
        path: '/multicolli',
      });
    }

    return next({
      path: '/',
    });
  }

  if (to.path === '/') {
    const isMulticolliMerchant = LocalStorage.isMulticolliMerchant();
    if (isMulticolliMerchant) {
      return next({
        path: '/multicolli',
      });
    }
  } else if (to.path === '/multicolli') {
    const isMulticolliMerchant = LocalStorage.isMulticolliMerchant();
    if (!isMulticolliMerchant) {
      return next({
        path: '/',
      });
    }
  }

  return next();
});

export default router;
